<template>
  <div v-if="showing" class="fixed inset-0 w-full h-screen flex items-center justify-center" style="z-index: 99997; background: rgba(0,0,0,0.2);" @click.self="close">
    <div class="relative w-full max-w-screen-md bg-white shadow-lg rounded-lg p-6" style="z-index: 99998">
      <button aria-label="close" class="absolute top-0 right-0 text-xl text-gray-500 my-2 mx-4" @click.prevent="close">×</button>
      <slot />
    </div>
  </div>
</template>

<script>

export default {
  props: {
    showing: {
      required: true,
      type: Boolean,
    },
  },
  emits: ['close'],
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector('body').classList.add('overflow-hidden')
      }
      document.querySelector('body').classList.remove('overflow-hidden')
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
  },
}

</script>
